import {
  Avatar,
  Button,
  Form,
  Input,
  Select,
  Spin,
  message
} from "antd";

import {
  EditOutlined,
  MailOutlined,
  PhoneOutlined,
  SaveOutlined,
  UserOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import AccountShell
  from "./accountShell";

import {
  getAccountProfile,
  updateAccountProfile
} from "../../api/account";

export default function PersonalInfo() {
  const [profile, setProfile] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [editing, setEditing] =
    useState(false);

  const [form] = Form.useForm();

  const load = async () => {
    try {
      setLoading(true);

      const res =
        await getAccountProfile();

      const data =
        res?.data?.data || null;

      setProfile(data);

      form.setFieldsValue({
        fullname:
          data?.fullname || "",

        phone:
          data?.phone || "",

        birthday:
          data?.birthday
            ? String(data.birthday).slice(0, 10)
            : "",

        gender:
          data?.gender || "",

        photos:
          data?.photos || ""
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async values => {
    try {
      const res =
        await updateAccountProfile(values);

      const data =
        res?.data?.data;

      setProfile(data);

      const old =
        JSON.parse(
          localStorage.getItem("user") ||
          "{}"
        );

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...old,
          ...data,
          token: old?.token
        })
      );

      message.success(
        "Cập nhật thông tin thành công."
      );

      setEditing(false);
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
        "Không thể cập nhật thông tin."
      );
    }
  };

  return (
    <AccountShell
      title="Thông tin cá nhân"
      description="Quản lý hồ sơ và thông tin tài khoản"
      action={
        !editing && (
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() =>
              setEditing(true)
            }
          >
            Chỉnh sửa
          </Button>
        )
      }
    >
      <Spin spinning={loading}>
        {!editing ? (
          <div>
            <div
              className="
                flex
                items-center
                gap-4
                mb-6
              "
            >
              <Avatar
                size={76}
                src={
                  profile?.photos ||
                  undefined
                }
                className="
                  !bg-blue-50
                  !text-blue-600
                  font-bold
                  text-xl
                "
              >
                {!profile?.photos &&
                  String(
                    profile?.fullname ||
                    profile?.email ||
                    "K"
                  )
                    .charAt(0)
                    .toUpperCase()}
              </Avatar>

              <div>
                <p
                  className="
                    text-[18px]
                    font-bold
                    text-slate-900
                    m-0
                  "
                >
                  {profile?.fullname ||
                    profile?.displayName ||
                    "Chưa cập nhật"}
                </p>

                <p
                  className="
                    text-[12px]
                    text-slate-400
                    mt-1
                    mb-0
                  "
                >
                  {profile?.email}
                </p>
              </div>
            </div>

            <div
              className="
                grid
                grid-cols-1
                md:grid-cols-2
                gap-3
              "
            >
              {[
                [
                  "Họ và tên",
                  profile?.fullname ||
                    "Chưa cập nhật",
                  <UserOutlined />
                ],
                [
                  "Email",
                  profile?.email ||
                    "Chưa cập nhật",
                  <MailOutlined />
                ],
                [
                  "Số điện thoại",
                  profile?.phone ||
                    "Chưa cập nhật",
                  <PhoneOutlined />
                ],
                [
                  "Ngày sinh",
                  profile?.birthday
                    ? String(
                        profile.birthday
                      ).slice(0, 10)
                    : "Chưa cập nhật",
                  null
                ],
                [
                  "Giới tính",
                  profile?.gender === "male"
                    ? "Nam"
                    : profile?.gender === "female"
                    ? "Nữ"
                    : profile?.gender === "other"
                    ? "Khác"
                    : "Chưa cập nhật",
                  null
                ]
              ].map(([label, value, icon]) => (
                <div
                  key={label}
                  className="
                    bg-slate-50
                    rounded-2xl
                    p-4
                  "
                >
                  <p
                    className="
                      text-[11px]
                      text-slate-400
                      m-0
                    "
                  >
                    {label}
                  </p>

                  <div
                    className="
                      flex
                      items-center
                      gap-2
                      mt-1
                    "
                  >
                    {icon}

                    <p
                      className="
                        text-[14px]
                        font-semibold
                        text-slate-800
                        m-0
                        break-all
                      "
                    >
                      {value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={save}
          >
            <Form.Item
              name="fullname"
              label="Họ và tên"
              rules={[
                {
                  required: true,
                  message:
                    "Vui lòng nhập họ và tên"
                }
              ]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Email"
            >
              <Input
                size="large"
                value={profile?.email}
                disabled
              />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Số điện thoại"
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              name="birthday"
              label="Ngày sinh"
            >
              <Input
                size="large"
                type="date"
              />
            </Form.Item>

            <Form.Item
              name="gender"
              label="Giới tính"
            >
              <Select
                size="large"
                allowClear
                options={[
                  {
                    value: "male",
                    label: "Nam"
                  },
                  {
                    value: "female",
                    label: "Nữ"
                  },
                  {
                    value: "other",
                    label: "Khác"
                  }
                ]}
              />
            </Form.Item>

            <Form.Item
              name="photos"
              label="Ảnh đại diện"
              extra="Có thể nhập đường dẫn ảnh đại diện."
            >
              <Input
                size="large"
                placeholder="https://..."
              />
            </Form.Item>

            <div
              className="
                flex
                gap-2
              "
            >
              <Button
                size="large"
                onClick={() => {
                  setEditing(false);
                  load();
                }}
              >
                Hủy
              </Button>

              <Button
                size="large"
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
              >
                Lưu thay đổi
              </Button>
            </div>
          </Form>
        )}
      </Spin>
    </AccountShell>
  );
}
